import { PostingModel } from "app/models/PostModel";
import { usePostingFormBase } from "app/utils/hooks/usePostingFormBase";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "typedefs";

interface Props {
  onPost?: (post: PostingModel) => void;
}

export const useGroupPostingForm = ({ onPost }: Props) => {
  const { selectedGroup } = useSelector(
    (state: RootState) => state.groups,
    shallowEqual,
  );

  const { user, canSchedulePosts, canUploadMedia, postActions } =
    usePostingFormBase({
      entityPlanPermissions: selectedGroup?.planPermissions,
    });

  const onSubmit = (data: PostingModel) => {
    if (selectedGroup) {
      postActions
        .createPost({ ...data, team_ids: [selectedGroup.id] })
        .then((res) => {
          if (res && onPost) {
            onPost(res);
          }
        });
    }
  };

  return {
    canUploadMedia,
    canSchedulePosts,
    user,
    onSubmit,
  };
};
